<template>
  <div>
    <a-radio-group v-model="currentValue" @change="onValueChange">
      <a-radio
        :key="item.code"
        :value="item.code"
        v-for="item in options"
        :title="item.code">{{item.name}}
      </a-radio>
    </a-radio-group>
  </div>
</template>

<script>
export default {
  name: 'DictRadio',
  props: {
    dictCode: String,
    value: String,
  },
  data() {
    return {
      options: [],
      currentValue: this.value,
    };
  },
  watch: {
    currentValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.currentValue = val;
    },
  },
  methods: {
    onValueChange() {
    },
  },
  created() {
    const dictData = this.$store.getters.getDictionaryByKey(this.dictCode);
    this.options = dictData.data;
  },
};
</script>

<style scoped>

</style>
